import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_WorkspaceAnalysisFolderTree = _resolveComponent("WorkspaceAnalysisFolderTree")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.workspaceAnalysisViewShareDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workspace.myRepository.destinationFolder')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.shareDocument
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.share')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_WorkspaceAnalysisFolderTree, {
        propFolders: _ctx.folders,
        onFoldersSelected: _ctx.setSelectedFolders
      }, null, 8, ["propFolders", "onFoldersSelected"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}